module.exports = __webpack_public_path__ + "img/article-image-placeholder.df7d468e.png";